import React from 'react';
import styled from 'styled-components';

import breakpoints from '../styles/breakpoints';

import List, { ListItem, Label, Value } from '../components/List';

const getPartLabelsString = (label1, label2) => {
  try {
    label1 = label1.trim();
    label2 = label2.trim();
  } catch (e) {}
  let label = '';

  if (label1) {
    label = label1;
  }

  if (label2) {
    if (label) {
      label += '<br>';
    }

    label += label2;
  }

  return label;
};

const checkIfShouldDisplay = value => {
  if (typeof value === 'string') {
    return !!value.trim();
  }

  return !!value;
};

const StyledCarPartInfo = styled.div`
  margin: 0 auto 60px auto;
  max-width: ${p => p.theme.globalWidthXSmall};
`;

const Title = styled.h2`
  margin-bottom: 20px;

  ${breakpoints.medium`
    margin-bottom: 33px;
  `};

  ${breakpoints.large`
    margin-bottom: 44px;
  `};
`;

export default function CarPartInfo({ part }) {
  return (
    <StyledCarPartInfo>
      <Title>Info om delen</Title>

      <List columns={2}>
        {checkIfShouldDisplay(part.stockNumber) && (
          <ListItem>
            <Label>Lagernummer:</Label> <Value>{part.stockNumber}</Value>
          </ListItem>
        )}
        {checkIfShouldDisplay(part.boschNumber) && (
          <ListItem>
            <Label>Boschnummer:</Label> <Value>{part.boschNumber}</Value>
          </ListItem>
        )}
        {checkIfShouldDisplay(part.articleNumber) && (
          <ListItem>
            <Label>Artikkelnummer:</Label> <Value>{part.articleNumber}</Value>
          </ListItem>
        )}
        {checkIfShouldDisplay(part.originalCode) && (
          <ListItem>
            <Label>Originalnummer:</Label> <Value>{part.originalCode}</Value>
          </ListItem>
        )}

        {checkIfShouldDisplay(
          getPartLabelsString(part.partLabel1, part.partLabel2)
        ) && (
          <ListItem>
            <Label>Anmerkning:</Label>{' '}
            <Value
              dangerouslySetInnerHTML={{
                __html: getPartLabelsString(part.partLabel1, part.partLabel2)
              }}
            />
          </ListItem>
        )}

        {checkIfShouldDisplay(part.quality) && (
          <ListItem>
            <Label>Kvalitet:</Label> <Value>{part.quality}</Value>
          </ListItem>
        )}
        {checkIfShouldDisplay(part.qualityDescription) && (
          <ListItem>
            <Label>Kommentar:</Label> <Value>{part.qualityDescription}</Value>
          </ListItem>
        )}
        <ListItem>
          <Label>Forventet leveringstid:</Label>{' '}
          <Value>
            {part.country === 'Norge' && '2-3 dager.'}
            {part.country === 'Sverige' && '5-7 dager.'}
          </Value>
        </ListItem>
      </List>

      <Title>Info om bilen delen kommer fra</Title>

      <List columns={2}>
        {checkIfShouldDisplay(part.carLabel) && (
          <ListItem>
            <Label>Anmerkning:</Label> <Value>{part.carLabel}</Value>
          </ListItem>
        )}
        {checkIfShouldDisplay(part.modelYear) && (
          <ListItem>
            <Label>Årsmodell:</Label> <Value>{part.modelYear}</Value>
          </ListItem>
        )}
        {checkIfShouldDisplay(part.regNumber) && (
          <ListItem>
            <Label>Reg.nr.:</Label> <Value>{part.regNumber}</Value>
          </ListItem>
        )}
        {checkIfShouldDisplay(part.vin) && (
          <ListItem>
            <Label>Chassisnr.:</Label> <Value>{part.vin}</Value>
          </ListItem>
        )}
        {checkIfShouldDisplay(part.mileage) && (
          <ListItem>
            <Label>Km.stand:</Label> <Value>{part.mileage}</Value>
          </ListItem>
        )}
        {checkIfShouldDisplay(part.chassis) && (
          <ListItem>
            <Label>Karosseri:</Label> <Value>{part.chassis}</Value>
          </ListItem>
        )}
        {checkIfShouldDisplay(part.carColor) && (
          <ListItem>
            <Label>Farge:</Label> <Value>{part.carColor}</Value>
          </ListItem>
        )}
        {checkIfShouldDisplay(part.engine) && (
          <ListItem>
            <Label>Motor:</Label> <Value>{part.engine}</Value>
          </ListItem>
        )}
        {checkIfShouldDisplay(part.gearBox) && (
          <ListItem>
            <Label>Girkasse:</Label> <Value>{part.gearBox}</Value>
          </ListItem>
        )}
      </List>
    </StyledCarPartInfo>
  );
}
